module.exports = __webpack_public_path__ + "img/lifetimeHouse.271e11e.svg";